import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import usePushNotifications from "../hooks/usePushNotifications";

const MemberAuth = ({ children }) => {
    const navigate = useNavigate();
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        const memberToken = localStorage.getItem("memberAccessToken");
        const isOnboarding = localStorage.getItem("isOnboarding") === "true";
        const isAuthenticated = !!memberToken && !isOnboarding;
        if (!isAuthenticated) {
            navigate("/login", { replace: true });
            return;
        }
        setChecked(true);
    }, [navigate]);
    usePushNotifications(checked);
    if (!checked) return null;

    return <>{children}</>;
};

export default MemberAuth;